import { Assistant } from "@mui/icons-material";
import { Paper, CircularProgress, Box, Link } from "@mui/material";
import IconInfo from '@mui/icons-material/Info';
import IconDelete from '@mui/icons-material/Delete';
import { NoLinksFound, BufferedNewLength, ScrapReportLinksCount } from "./scrap-report-helpers";

import { LinkAnalysed, LinkNotAnalysed } from "./links-analyzed-not-analyzed";

export default function ScrapReport({scrapReport, handleOpenChildClicked, handleLinkClicked, handleInfoClick, handleDeleteClick, analysisIsRunning, linksInStorylineReady, linksInStoryline, handleAnalysisClick, loadList}){

    const news = [];
    const jobs = [];
    const unrelevant = [];

    let failedAnalysis = false;

    if(scrapReport.analysisResult){
        for(const link of scrapReport.analysisResult){
            if(typeof(link.link) != "string"){
                failedAnalysis = true;
            }
            else{
                if(link.isArticle){
                    news.push(link);
                }
                else if(link.isJob){
                    jobs.push(link);
                }
                else{
                    unrelevant.push(link);
                }
            }
        }
    }

    function handleOpenScrapedPagedClicked(){
        handleOpenChildClicked(scrapReport.scraper);
    }

    return (
        <Paper sx={{ padding: scrapReport.success?3:1, marginBottom: scrapReport.success?1:0 }} elevation={scrapReport.success?4:1}>
            <b><Link onClick={ handleOpenScrapedPagedClicked } >{ scrapReport.scraper.name }</Link></b>
            { 
                scrapReport.success?<>
                    <br/>
                    { analysisIsRunning?<CircularProgress />:<Assistant onClick={() => handleAnalysisClick(scrapReport)}/> }
                    <IconInfo onClick={() => handleInfoClick(scrapReport)}/>
                    <IconDelete onClick={() => handleDeleteClick(scrapReport)} />
                    <ScrapReportLinksCount scrapReport={ scrapReport }/>
                </>:<></>
            }
            
            <br/>
            {
                failedAnalysis?<>Error in links analysis<br /></>:<></>
            }
            {
                scrapReport.bufferedNew?
                    <>
                        { 
                            scrapReport.analysisResult?<>
                            {
                                news.map(linkAnalysed => {
                                    return linkAnalysed.isArticle?<LinkAnalysed linkAnalysed={linkAnalysed} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleLinkClicked} loadList={loadList}/>:<></>
                                })
                            }
                            {
                                jobs.map(linkAnalysed => {
                                    return linkAnalysed.isJob?<LinkAnalysed linkAnalysed={linkAnalysed} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleLinkClicked} loadList={loadList}/>:<></>
                                })
                            }
                            {
                                unrelevant.length > 0?
                                    <Paper elevation={4} sx={{padding: 4}}>
                                        Unrelevant or unable to process
                                        <br/>
                                        {
                                            scrapReport.analysisResult.map(linkAnalysed => {
                                                return (!linkAnalysed.isArticle && !linkAnalysed.isJob)?<LinkAnalysed linkAnalysed={linkAnalysed} scrapReport={scrapReport} linksInStoryline={linksInStoryline} linksInStorylineReady={linksInStorylineReady} handleOpenClick={handleLinkClicked} loadList={loadList} />:<></>
                                            })
                                        }
                                    </Paper>
                                :<></>
                            }
                            </>
                            :<>
                            {
                                scrapReport.bufferedNew.map(link => {
                                    return <LinkNotAnalysed link={link} scrapReport={scrapReport} linksInStoryline={linksInStoryline} linksInStorylineReady={linksInStorylineReady} handleOpenClick={handleLinkClicked}/>
                                })
                            }
                            </>
                        }
                    </>
                :<>Buffered new not available</>
            }
            {
                scrapReport.success?<>
                    <Box sx={{ display:'flex', alignItems:'flex-end' }}><IconDelete onClick={() => handleDeleteClick(scrapReport)}  sx={{ marginLeft: "auto" }}></IconDelete></Box>
                </>:<><IconDelete onClick={() => handleDeleteClick(scrapReport)} />{ scrapReport.errorMessage }</>
            }
            
        </Paper>
    )
}
